/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { css } from "@panda/css";

export const authOuter = css({
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	minHeight: "60vh", //matches app min-height
	w: "full",
	h: "full",
	padding: "eds.dimension.48",
	smDown: {
		paddingBlock: "eds.dimension.32",
		paddingInline: "eds.dimension.24",
	},
});

export const authBox = css({
	borderRadius: "eds.borderRadius.24",
	border: "1px solid token(colors.eds.border.subtle)",
	background: "eds.background.elevated.low.default",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	w: "560px",
	padding: "eds.dimension.48",
	textAlign: "center",
	smDown: {
		padding: "eds.dimension.32",
	},
});

export const linkStyles = css({
	color: "eds.text.link.primary.default",
	textDecoration: "underline",
	textStyle: "paragraphMD",
	_hover: {
		color: "eds.text.link.primary.press",
	},
});
